const { setCookie } = window.BAO.Utils

class ProductDrawerNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'form',
      'email',
      'error',
      'subscribe-text',
      'success-text',
      'subscribe-form',
      'copy-text',
    ]
  }

  constructor () {
    super()

    this.defaultProperties = {
      signup_source: 'pdp_drawer',
    }
    this.submittedStorageName = 'BAO-drawer-newsletter-submitted'
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.shouldShowPopup()) {
      // this.style.display = 'none'
      // this.externalEls.trigger.element.style.display = 'none'
    }

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit.bind(this),
    )

    this.listeners.add(
      this.els.email.element,
      'input',
      this.handleEmailInput.bind(this),
    )

    this.listeners.add(
      this.els.code.element,
      'click',
      this.handleCodeCopy.bind(this),
    )
    this.listeners.add(
      this.els['copy-text'].element,
      'click',
      this.handleCodeCopy.bind(this),
    )
  }

  handleCodeCopy () {
    const code = this.els.code.element.innerText
    navigator.clipboard.writeText(code)

    this.els['copy-text'].element.innerText = this.els[
      'copy-text'
    ].element.getAttribute('data-copied-text')
  }

  handleEmailInput () {
    if (this.validEmail()) {
      this.els.email.element.setAttribute('aria-invalid', false)
      this.els.submit?.element?.removeAttribute('aria-disabled')
      this.els.submit?.element?.removeAttribute('disabled')
    } else {
      this.els.email.element.setAttribute('aria-invalid', true)
      this.els.submit?.element?.setAttribute('aria-disabled', true)
      this.els.submit?.element?.setAttribute('disabled')
    }
  }

  async onFormSubmit (e) {
    e.preventDefault()

    if (!window.theme?.ometria) return

    const emailAddress = this?.els?.email?.element?.value.replace(/\s/g, '')

    if (!this.validEmail()) {
      this.els.email.element.setAttribute('aria-invalid', true)
      this.els.email.element.focus()
      return
    }

    // Profile lookup disabled until there's an Ometria equivalent of the
    // self-portrait-klaviyo.vercel.app `identify` endpoint.
    /*
    // Check if profile exists already before submitting.
    const profileExists = await this.checkProfileExists(emailAddress)

    // If profile already exists, skip to register form.
    if (profileExists) {
      this.log('Profile already exists')
      this.toggleErrorMessage(window.theme.strings.newsletterEmailInUse)
      return
    }
    */

    this.createClientSubscription({
      emailAddress,
    })
  }

  // Klaviyo API Methods.
  async checkProfileExists (emailAddress) {
    const scriptUrl = 'https://self-portrait-klaviyo.vercel.app/api/identify'

    const data = {
      email: emailAddress,
      store: window.theme?.klaviyo?.store,
    }

    const response = await fetch(scriptUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const jsonResponse = await response.json()

    return jsonResponse.registered ? jsonResponse.registered : false
  }

  async createClientSubscription (formData) {
    const { emailAddress } = formData
    const properties = { ...this.defaultProperties }

    // Ometria's AJAX forms endpoint takes urlencoded fields, with custom fields
    // prefixed with `properties.`. `email` and `__email` are honeypots and must be empty.
    // https://support.ometria.com/hc/en-gb/articles/360011168777-Setting-up-Ajax-forms
    const bodyData = new URLSearchParams({
      __form_id: window.theme.ometria.formId,
      email: '',
      __email: '',
      '@account': window.theme.ometria.account,
      '@subscription_status': 'SUBSCRIBED',
      ue: emailAddress,
    })

    Object.entries(properties).forEach(([key, value]) => {
      bodyData.append(`properties.${key}`, value)
    })

    const options = {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: bodyData,
    }

    try {
      const response = await fetch(window.theme.ometria.endpoint, options)

      // Returns `{ ok, errors }`, where each error is a `[field, message]` pair.
      const jsonResponse = await response.json()

      if (jsonResponse.ok) {
        this.toggleErrorMessage()
        this.showSubscribedMessage()

        // Markdown 2025
        this.markdownSale()
      } else {
        if (jsonResponse.errors.length > 0) {
          // eslint-disable-next-line no-console
          const errorMessage = jsonResponse.errors[0]?.[1]
            ? jsonResponse.errors[0][1]
            : window.theme.strings.newsletterGenericError
          this.toggleErrorMessage(errorMessage)
        }
      }
    } catch (error) {
      console.error(error)
      const errorMessage =
        error && error.detail
          ? error.detail
          : window.theme.strings.newsletterGenericError
      this.toggleErrorMessage(errorMessage)
    }
  }

  markdownSale () {
    if (!window.theme.saleMarkdownEnable) return

    this.setNewCustomerStorage()
    this.setExistingCustomerStorage()

    localStorage.setItem('single_show_thankyou', 'true')

    if (this.dataset.mdSaleRedirect) {
      window.location.href = this.dataset.mdSaleRedirect
    }
  }

  toggleErrorMessage (message = false) {
    const errorElement = this.els.error.element
    if (!message) {
      errorElement.setAttribute('aria-hidden', true)
    } else {
      errorElement.setAttribute('aria-hidden', false)
      errorElement.innerHTML = message
    }
  }

  showSubscribedMessage () {
    window.localStorage.setItem(this.submittedStorageName, true)

    // Hide subscribe form
    this.els['subscribe-text'].element.setAttribute('aria-hidden', true)
    this.els['subscribe-form'].element.setAttribute('aria-hidden', true)

    // // Show registered text
    this.els['success-text'].element.setAttribute('aria-hidden', false)
  }

  validEmail () {
    const emailAddress = this?.els?.email?.element?.value.replace(/\s/g, '')

    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return emailRegex.test(emailAddress)
  }

  /*
  change this to should show newsletter, and hide newsletter instead
  */
  shouldShowPopup () {
    let shouldShow = true

    // Don't show if popup has already been submitted
    if (window.localStorage.getItem(this.submittedStorageName) !== null) {
      shouldShow = false
    }

    return shouldShow
  }

  setExistingCustomerStorage () {
    setCookie(
      this.existingCustomerCookieName,
      'true',
      window.theme.saleExistingCustomerCookieExpiration || 7,
    )
  }

  setNewCustomerStorage () {
    setCookie(
      this.newCustomerCookieName,
      'true',
      window.theme.saleNewCustomerCookieExpiration || 1,
    )
  }

  get existingCustomerCookieName () {
    return (
      window.theme.saleExistingCustomerCookie || `BAO-md-2025-existingCustomer`
    )
  }

  get newCustomerCookieName () {
    return window.theme.saleNewCustomerCookie || `BAO-md-2025-newCustomer`
  }
}

if (!customElements.get('product-drawer-newsletter')) {
  customElements.define('product-drawer-newsletter', ProductDrawerNewsletter)
}
